import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  setCurrentStep,
  setShowPopUp,
  setSelectedActionType,
  setContactPersonSendFormType,
  setSelectedResponsible
} from '../OwnershipTransferSlice';
import SelectOptionExtendedButton from '../../../Shared/SelectOptionExtendedButton/SelectOptionExtendedButton';
import { FormSendType, OwnershipTransferActionSubType, EquipmentPaymentObligation, OwnershipTransferStep } from '../Constant/Constant';
import { TextInputEnum } from '../../../../utilities/validation/InputValidation';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';


const ContactPersonForm = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.CustomerDetailPage,
        messageText: DWHMessageText.CustomerDetailPageDisplayed,
        status: DWHStatus.Ongoing,

      });
    }
  }, []);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [errors, setErrors] = useState({ sms: '', email: '' });
  const [submitForm, setSubmitForm] = useState(false);
  const numberRegex = /^\d+$/;
  const [buttons, setButtons] = useState([
    {
      id: '0',
      label: 'SMS',
      value: FormSendType.sms,
      selected: props.data.contactPersonSendFormType.type === FormSendType.sms ? true : false,
      textInputValidationType: TextInputEnum.Phone,
      onChange: inputChangeHandler,
      inputValue: props.authentication.loginData.userDetails.contactNumber,
      pattern: '[0-9]*',
      maxLength: '10'
    },
    {
      id: '1',
      label: 'מייל',
      value: FormSendType.email,
      selected: props.data.contactPersonSendFormType === FormSendType.email ? true : false,
      textInputValidationType: TextInputEnum.Mail,
      onChange: inputChangeHandler,
      inputValue: props.data.contactPersonSendFormType === FormSendType.email ? props.data.contactPersonSendFormType.email : '',
    },
  ]);

  useEffect(() => {
    if (submitForm) {
      props.submitRequest();
    }
  }, [submitForm]);

  const equipmentTransferOptions = [
    {
      value: 'לחברה',
      key: EquipmentPaymentObligation.Organization,
    },
    {
      value: 'למנוי',
      key: EquipmentPaymentObligation.Customer,
    },
  ];

  function getTitle() {
    if (props.data.jetConnection && props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer) {
      return 'טופס לחתימה ישלח בסיום התהליך, לאחר מילוי הפרטים'
    }
    else {
      return 'טופס לחתימה שלך יישלח בסיום התהליך, לאחר מילוי הפרטים';
    }
  }

  function inputChangeHandler(type, value, error) {

    if (type === FormSendType.sms && value && !numberRegex.test(value)) { return null; }
    setButtons((buttonsData) => buttonsData.map((btn) => (btn.value === type ? { ...btn, inputValue: value } : btn)));
    setErrors({ ...errors, [type]: error });
    setShowErrorMsg(false);
  }

  function manageData(value) {
    let newButtonData = buttons.map((button) => {
      if (button.value === value) {
        button.selected = true;
      } else {
        button.selected = false;
      }
      return button;
    });
    setButtons(newButtonData);
  }


  async function nextStep() {
    let selectedFormSendType = buttons.find((button) => button.selected);
    if (!selectedFormSendType || errors[selectedFormSendType.value] !== '' || selectedFormSendType.inputValue.trim() === '' || (props.data.jetConnection && props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer && props.data.responsibleForNextPayments == EquipmentPaymentObligation.None)) {
      setShowErrorMsg(true);
    } else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.CustomerDetailPage,
        messageText: DWHMessageText.CustomerDetailPageButtonClicked,
        status: DWHStatus.Ongoing,
      });
      await props.setContactPersonSendFormType({ type: selectedFormSendType.value, value: selectedFormSendType.inputValue });
      setShowErrorMsg(false);
      if (props.data.jetConnection && props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer) {
        props.setCurrentStep(OwnershipTransferStep.UploadFile);
      }
      else {
        setSubmitForm(true);
      }
      //send data to server

    }
  }

  return (
    <div className='ownership-transfer-form stepContainer contact-person-form  ownership-transfer-step'>
      <div className='l-title '>פרטי איש הקשר</div>
      <div className='m-title center'>{getTitle()}</div>
      <div className='org-data'>
        <div className='title'>שם החברה:</div>
        <div className='org-name semi'>{props.portalsBlock.selectedOrgName}</div>
        <div className="border-line"></div>
        <div className='org-het-pay-data '>
          <div className='title'>ח״פ:</div>
          <div className='het-pay-num semi'>{props.portalsBlock.selectedHetPay}</div>
        </div>
      </div>
      <div className=''>
        <SelectOptionExtendedButton title={props.data.jetConnection ? 'לאן לשלוח את הטופס לחתימת איש הקשר?' : 'לאן לשלוח את הטופס לחתימה שלך?'} buttonsData={buttons} onClick={manageData} />
      </div>
      {(props.data.jetConnection && props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer) && (
        <div className='equipment-transfer-selection'>
          <div className='m-title semi center'>להעביר חיובי ציוד לחברה או למנויים ?</div>
          <div className='m-title center'>*הבחירה הינה גורפת עבור כל המנויים שבקובץ</div>
          <ReactSelect
            inputProps={{ readOnly: true }}
            isSearchable={false}
            //error={props.form.errors.arrivalTime}
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.key}
            placeholder='בחרו למי להעביר חיובי ציוד'
            value={equipmentTransferOptions.filter((option) => option.key == props.data.responsibleForNextPayments).value}
            name='equipmentTransfer'
            options={equipmentTransferOptions}
            onChange={(e) =>
              props.setSelectedResponsible(e.key)
            }
          />
        </div>
      )}
      <div className='continue-button'>
        {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
        <BtnSubmit onclick={nextStep} text={'אישור ושליחת הטפסים לחתימה'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
  userDetails: state.authentication?.loginData?.userDetails,

});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedActionType,
  setContactPersonSendFormType,
  setSelectedResponsible
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPersonForm);
